<template>
  <div class="flex flex-col md:py-12">
    <div
      class="w-full md:max-w-screen-sm flex flex-col bg-white rounded-sm shadow mx-auto py-10 px-10 mt-5"
    >
      <h2 class="text-2xl py-1">Reset Your Password</h2>

      <p class="py-3">
        Enter your email address and we'll send you an email with instructions for resetting your
        password.
      </p>

      <div class="flex flex-col">
        <label for="email" class="block"> Email </label>
        <SingleLineInput
          id="email"
          type="email"
          placeholder="email@email.com"
          :value="email"
          @input="email = $event.target.value"
        ></SingleLineInput>
      </div>

      <div class="flex w-full md:w-1/2 mx-auto py-5">
        <PrimaryButton @click="requestReset" @disabled="isUserLoading" :is-loading="isUserLoading"
          >Send me instructions</PrimaryButton
        >
      </div>

      <router-link
        :to="{ name: 'home_login' }"
        class="text-brand-mid-gray underline cursor-pointer py-1 text-sm text-center"
        >Back to Login</router-link
      >
      <router-link
        :to="{ name: 'home_signup' }"
        class="text-brand-mid-gray underline cursor-pointer py-1 text-sm text-center"
        >Don't have an account? Sign Up</router-link
      >
    </div>
  </div>
  <ActionToast ref="passwordResetToast" />
</template>
<script>
import { mapGetters } from "vuex"
import { USER_REQUEST_PASSWORD_RESET } from "@/store/types"

export default {
  computed: {
    ...mapGetters(["isUserLoading"])
  },
  data() {
    return {
      email: ""
    }
  },
  methods: {
    async requestReset() {
      if (!this.email) {
        return
      }
      const { email } = this
      await this.$store.dispatch(USER_REQUEST_PASSWORD_RESET, {
        email
      })

      this.email = ""

      this.$refs.passwordResetToast.show({
        type: "success",
        hasClose: true,
        content:
          "You will receive an email with instructions on how to reset your password. If you don't receive it within 5 minutes, check your spam or junk folder, or contact customer support.",
        icon: "check"
      })
    }
  }
}
</script>
